import * as go from 'gojs';
import { makePort } from './makePort';

export const InputPort = makePort('TriangleDown', {
  toLinkable: true,
  fromMaxLinks: 1,
  toMaxLinks: 1,
  toSpot: go.Spot.Top,
  toEndSegmentLength: 10,
  name: 'INPUTPORT',
});
